import React, { FC, useCallback } from 'react';
import { confirm, notification } from 'src/common';
import { useTranslation } from 'react-i18next';
import modalStyles from 'src/common/Modal/index.module.scss';
import { QuickActions, QuickActionsItem, QuickActionsDivider } from 'src/shared';
import { useOpenSidebar } from 'src/shared/InfoSidebar/hooks';
import { SidebarMode } from 'src/shared/InfoSidebar/types';
import { faPen, faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { getUpdateCacheOnDeleteMp, useDeleteMp } from 'src/models/matchingProfiles/hooks';
import { useApiTenders } from 'src/models/procurements/Tenders/hooks';

export const SavedSearchQuickActions: FC = () => {
  const { t } = useTranslation();
  const openEcPreview = useOpenSidebar();
  const [deleteSavedSearch] = useDeleteMp();
  const [{ vars }, updateSearchArgs] = useApiTenders();
  const mpId = vars.profileId;
  const showDrawer = useCallback(() => {
    openEcPreview({ id: vars.matchingProfileId || null, mode: SidebarMode.EC_INFO });
  }, [openEcPreview, vars.matchingProfileId]);

  const onDeleteSavedSearch = useCallback(() => {
    if (mpId) {
      confirm.confirm({
        title: t('ExpiringContracts.removeSavedSearchConfirmTitle'),
        content: t('ExpiringContracts.removeSavedSearchConfirmQuestion'),
        okText: t('Common.delete'),
        cancelText: t('Common.cancel'),
        className: modalStyles.confirmModal,
        centered: true,
        onOk() {
          deleteSavedSearch({
            variables: { id: mpId },
            update: getUpdateCacheOnDeleteMp(mpId, true),
            optimisticResponse: {
              __typename: 'Mutation',
              deleteMatchingProfile: true
            }
          })
            .then(() => {
              updateSearchArgs({ profileId: undefined });
            })
            .catch(() => {
              notification.error({
                description: t('Common.unknownErrorDesc'),
                message: t('Common.unknownError')
              });
            });
        }
      });
    }
  }, [mpId, t, deleteSavedSearch, updateSearchArgs]);

  return (
    <QuickActions>
      <QuickActionsItem onClick={showDrawer} title={t('ExpiringContracts.editSavedSearch')} key={'edit'} icon={faPen} />
      <QuickActionsDivider />
      <QuickActionsItem
        onClick={onDeleteSavedSearch}
        title={t('ExpiringContracts.deleteSavedSearch')}
        key={'delete'}
        icon={faTrashCan}
        danger
      />
    </QuickActions>
  );
};

export default SavedSearchQuickActions;
